import SwerveSmall from '../../../Icons/Robots/SwerveSmall';
import { getFieldGeometry, normalizeFieldSelection, resolveFieldSvg } from './fields';
import { clampCoordinateToBounds } from '../../../../utils/fieldSelection';

interface DUOrientationSVGProps {
  x: number;
  y: number;
  yaw: number;
  fieldType: unknown;
}

const FieldSVG = ({ x, y, yaw, fieldType }: DUOrientationSVGProps) => {
  const SIZE = 430;
  const fieldSelection = normalizeFieldSelection(fieldType);
  const fieldGeometry = getFieldGeometry(fieldSelection);
  const fieldAspectRatio = fieldGeometry.widthCm / fieldGeometry.heightCm;
  const fieldWidth = SIZE;
  const fieldHeight = SIZE / fieldAspectRatio;
  const fieldX = 0;
  const fieldY = (SIZE - fieldHeight) / 2;
  const scaleX = fieldWidth / fieldGeometry.widthCm;
  const scaleY = fieldHeight / fieldGeometry.heightCm;

  const robotWidth = fieldWidth * 0.08;
  const robotHeight = robotWidth;
  const clampedFieldX = clampCoordinateToBounds(fieldGeometry.widthCm / 2 - x, fieldGeometry.widthCm);
  const clampedFieldY = clampCoordinateToBounds(fieldGeometry.heightCm / 2 + y, fieldGeometry.heightCm);
  const robotCx = fieldX + clampedFieldX * scaleX;
  const robotCy = fieldY + clampedFieldY * scaleY;
  const robotX = robotCx - robotWidth / 2;
  const robotY = robotCy - robotHeight / 2;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="100%"
      height="100%"
      viewBox={`0 0 ${SIZE} ${SIZE}`}
      fill="none"
    >
      {resolveFieldSvg(fieldSelection, {
        id: `field-${fieldSelection.family}-${fieldSelection.variant}`,
        x: fieldX,
        y: fieldY,
        width: fieldWidth,
        height: fieldHeight,
      })}
      <g transform={`rotate(${-yaw + 180}, ${robotCx}, ${robotCy})`}>
        <SwerveSmall color="#000" x={robotX} y={robotY} width={robotWidth} height={robotHeight} />
      </g>
    </svg>
  );
};
export default FieldSVG;
